module.exports = __webpack_public_path__ + "img/img-thumb.04be3a5a.svg";